import { render, staticRenderFns } from "./FixParticipantForm.vue?vue&type=template&id=4d84904b&"
import script from "./FixParticipantForm.vue?vue&type=script&lang=js&"
export * from "./FixParticipantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports